import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive-bs4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import $ from "jquery";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import { useEffect, useRef } from "react";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import moment from "moment";
import { formatoMoneda } from "../../../../configuracion/validaciones";

const TablaPagosCompras = ({ datos, idTabla }) => {
    const { token } = useContextUsuario();
    const { setListaPagosVentas, ActualizarLista } = useContextEmpleado();
    const tableRef = useRef();

    useEffect(() => {
        if ($.fn.DataTable.isDataTable(`#${idTabla}`)) {
            $(`#${idTabla}`).DataTable().destroy();
        }

        $(tableRef.current).DataTable({
            data: datos,
            columns: [
                { title: "ID", data: "id" },
                {
                    title: "Monto Total",
                    data: "recibido",
                    render: (data) => {
                        const valorFormateado = formatoMoneda(data);
                        return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
                    }
                },
                {
                    title: "Fecha",
                    data: "fecha",
                    render: (fecha) => {
                        const f = moment(fecha);
                        return f.isValid() ? f.format("DD/MM/YYYY") : "N/A";
                    }
                },
                {
                    title: "Estado",
                    data: "estado",
                    render: (estado) => {
                        let badgeClass = "badge bg-secondary";
                        if (estado === "Completado") badgeClass = "badge bg-primary";
                        else if (estado === "Anulada") badgeClass = "badge bg-danger";
                        else if (estado === "Pendiente") badgeClass = "badge bg-warning text-dark";
                        else if (estado === "Procesando") badgeClass = "badge bg-info";
                        return `<span class="${badgeClass}">${estado ?? 'Sin estado'}</span>`;
                    }
                },
                {
                    title: "Método y Monto",
                    data: null,
                    render: (row) => {
                        const formatter = new Intl.NumberFormat("es-HN", {
                            style: "currency",
                            currency: "HNL"
                        });
                        let html = "<div class='d-flex flex-column gap-1'>";

                        if (row.pagoefectivos?.length > 0) {
                            const total = row.pagoefectivos.reduce((sum, p) => sum + (p.monto || 0), 0);
                            html += `<span class="badge bg-success">Efectivo: ${formatter.format(total)}</span>`;
                        }
                        if (row.pagotarjeta?.length > 0) {
                            const total = row.pagotarjeta.reduce((sum, p) => sum + (p.monto || 0), 0);
                            html += `<span class="badge bg-info">Tarjeta: ${formatter.format(total)}</span>`;
                        }
                        if (row.pagotransferencia?.length > 0) {
                            const total = row.pagotransferencia.reduce((sum, p) => sum + (p.monto || 0), 0);
                            html += `<span class="badge bg-warning text-dark">Transferencia: ${formatter.format(total)}</span>`;
                        }

                        html += "</div>";
                        return html === "<div class='d-flex flex-column gap-1'></div>"
                            ? `<span class="badge bg-secondary">Sin pago</span>` : html;
                    }
                }
            ],
            paging: true,
            lengthChange: true,
            pageLength: 10,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: true,
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            dom:
                "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            responsive: true,
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                infoPostFix: "",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                zeroRecords: "Sin resultados encontrados",
                search: "Buscar",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            destroy: true,
        });
    }, [datos, idTabla]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                id={idTabla}
                className="table table-bordered table-hover"
            ></table>
        </div>
    );
};

export default TablaPagosCompras;